import Http from '../api/http';
export default class JobType extends Http {
  constructor() {
    super();
  }
  jobType_getTreeList() {
    return super.post('jobType/getTreeList', ...arguments);
  }
}
